const features = [
  {
    icon: 'ri-shield-check-line',
    title: '安全绿色',
    desc: '91免费聚合的资源均来自合法公开平台，全程 HTTPS 加密传输，无弹窗广告、无恶意跳转，保障你的设备和隐私安全。我们严格筛选每一条播放线路，让你安心享受免费在线视频。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速流畅',
    desc: '多线路智能切换 + CDN 加速分发，确保高清视频免费看流畅不卡顿。我们持续优化播放体验，即使在使用高峰时段也能保持稳定加载速度。支持 1080P 高清在线播放。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全端适配',
    desc: '无需安装任何 App 或插件，电脑、平板、手机打开浏览器就能看。移动端专为小屏优化，排版清晰、操作便捷。通勤、午休、睡前，随时随地畅享91免费电影。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-sm font-medium mb-4 whitespace-nowrap">
            平台优势
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            为什么选择91免费
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-4xl mx-auto">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="rounded-2xl bg-background-50 border border-background-200/60 p-6 md:p-8 text-center"
            >
              <div className="w-16 h-16 rounded-2xl bg-primary-100 flex items-center justify-center mx-auto mb-5">
                <i className={`${feat.icon} text-primary-500 text-2xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-900 mb-3">
                {feat.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}